import React from 'react'
import { useTranslation } from 'react-i18next'

import { getReason } from '../../../../utils/helpers/events'
import Gallery from '../../../../components/pdf/Gallery'
import LabelValue from '../../../../components/pdf/LabelValue'
import Separator from '../../../../components/pdf/Separator'

const StatusReasonLabelValue = ({ serviceOrder }) => {
  const { t } = useTranslation('serviceOrders')
  const reason = getReason(serviceOrder)
  if (!reason) return false

  const { description, minicrudName, document } = reason
  let value = description
  if (minicrudName) value = `${minicrudName}: ${value}`

  return (
    <LabelValue label={t('pdf.reason')} value={value}>
      {!!document && (
        <>
          <Separator weight={4} />
          <Gallery items={[document]} />{' '}
        </>
      )}
    </LabelValue>
  )
}

export default StatusReasonLabelValue
